import { Stack, StackPage, StackSwitch, StackSwitchApiContext } from "@comet/admin";
import { AddCircleOutline } from "@mui/icons-material";
import { Button } from "@mui/material";
import { PageHeader } from "@src/components";
import { useContext } from "react";
import { FormattedMessage, useIntl } from "react-intl";

import AddForm from "./Form";
import Table from "./Table";

const AddButton = () => {
    const stackApi = useContext(StackSwitchApiContext);

    return (
        <Button
            variant="contained"
            color="primary"
            startIcon={<AddCircleOutline style={{ fontSize: "20px" }} />}
            onClick={() => stackApi.activatePage("add", "form")}
        >
            <FormattedMessage id="reviermanager.page.firmware.add" defaultMessage="Firmware hinzufügen" />
        </Button>
    );
};

export default () => {
    const intl = useIntl();

    return (
        <Stack topLevelTitle={intl.formatMessage({ id: "reviermanager.page.firmware", defaultMessage: "Firmware" })}>
            <StackSwitch initialPage="table">
                <StackPage name="table">
                    <PageHeader title={<FormattedMessage id="reviermanager.page.firmware" defaultMessage="Firmware" />} button={<AddButton />} />
                    <Table />
                </StackPage>
                <StackPage name="add" title={intl.formatMessage({ id: "reviermanager.page.firmware.add", defaultMessage: "Firmware hinzufügen" })}>
                    <AddForm />
                </StackPage>
            </StackSwitch>
        </Stack>
    );
};
